<template>
    <div class="t3m-Section-details t3m-Section-details--flx container-fluid isolate"
         ref="details">
        <div class="p-2 mt-1 mb-8 bg-white rounded t3m-Section-details-inner bg-opacity-10">
            <div class="flex flex-wrap t3m-Section-details-row">
                <div class="w-1/2 t3m-Section-details-col md:w-1/4 p-4px"
                     v-for="(s, indx) in selectedCard.subitems"
                     :key="indx">
                    <card-sub v-bind="s" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import CardSub from "@/components/Card/CardSub.vue";

export default {
    name: "VSectionDetails",
    components: {
        CardSub,
    },
    computed: {
        ...mapState(["selectedCard"]),
    },
    mounted() {
        this.scrollIntoView();
    },
    watch: {
        selectedCard: function () {
            this.scrollIntoView();
        },
    },
    methods: {
        scrollIntoView: function () {
            if (!this.selectedCard) {
                return;
            }

            let rect = this.$refs.details.getBoundingClientRect();
            let d = window.innerHeight - rect.bottom;

            if (d < 0) {
                window.scrollTo({
                    top: window.scrollY - d + 40,
                    behavior: 'smooth'
                });
            }
        },
    },
};
</script>
